export const PROVINCE_MAPPING = {
  'Alberta': 'ab',
  'British Columbia': 'bc',
  'Saskatchewan': 'sk',
  'Manitoba': 'mb',
  'Ontario': 'on',
  'Québec': 'qc',
  'New Brunswick': 'nb',
  'Nova Scotia': 'ns',
  'Prince Edward Island': 'pe',
  'Newfoundland and Labrador': 'nl',
  'Northwest Territories': 'nt',
  'Nunavut': 'nu',
  'Yukon': 'yt'
}

export const ACTIVE_PROVINCES = ['bc', 'ab', 'sk', 'on', 'qc']

export const LEGISLATURE_NAME_MAPPING = {
  'ab': 'Legislative Assembly of Alberta (2019 Provisional Results)',
  'bc': 'Legislative Assembly of British Columbia',
  'qc': 'Assemblée nationale du Québec',
  'sk': 'Legislative Assembly of Saskatchewan',
  'on': 'Legislative Assembly of Ontario',
  'fed': 'House of Commons of Canada'
}

export const PASSWORD_HASH = '3E7465342C3081AB448DAEEB4E8A7D5F26F63F50B594EBEE122806293313DD1D'



// WEBPACK FOOTER //
// ./src/constants.js